// constants/duitkuFormMethods.ts — Daftar metode Duitku untuk FORMULIR FISIK.
// Nilai `value` WAJIB sama persis dengan key DUITKU_PAYMENT_METHOD_MAP di
// wa-cuanmax/routes/duitku/paymentMethodMaps.js (backend mapping ke kode Duitku).
export const DUITKU_FORM_METHODS: Array<{ value: string; label: string }> = [
  { value: 'Duitku QRIS', label: 'QRIS (Otomatis)' },
  { value: 'Duitku BCA Virtual Account', label: 'BCA Virtual Account' },
  { value: 'Duitku Mandiri Virtual Account', label: 'Mandiri Virtual Account' },
  { value: 'Duitku BRI Virtual Account', label: 'BRI Virtual Account' },
  { value: 'Duitku BNI Virtual Account', label: 'BNI Virtual Account' },
  { value: 'Duitku Permata Virtual Account', label: 'Permata Virtual Account' },
  { value: 'Duitku CIMB Niaga Virtual Account', label: 'CIMB Niaga Virtual Account' },
  { value: 'Duitku OVO', label: 'OVO' },
  { value: 'Duitku DANA', label: 'DANA' },
  { value: 'Duitku ShopeePay', label: 'ShopeePay' },
  { value: 'Duitku LinkAja', label: 'LinkAja' },
  { value: 'Duitku Kartu Kredit', label: 'Kartu Kredit' },
];

export const isKnownDuitkuMethod = (v?: string | null): boolean =>
  !!v && DUITKU_FORM_METHODS.some(m => m.value === v);

export const duitkuMethodLabel = (v?: string | null): string =>
  DUITKU_FORM_METHODS.find(m => m.value === v)?.label || String(v || '');

// Label pendek utk UI sempit (form + switcher thanks-page): 'Duitku Mandiri
// Virtual Account' → 'VA Mandiri'. Non-VA tak berubah ('QRIS', 'OVO', ...).
export const duitkuShortLabel = (v?: string | null): string => {
  const full = duitkuMethodLabel(v).replace(/^Duitku\s+/i, '').replace(/\s*\(Otomatis\)\s*/i, '');
  const m = full.match(/^(.*)\s+Virtual Account$/i);
  return m ? `VA ${m[1].trim()}` : full;
};
